// components/FieldPalette.tsx
import React from 'react';
import { Paper, Text, Stack, Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { FieldTypeDef, FieldTypeCode } from '../types/BuilderField';

export interface FieldPaletteProps {
  types: FieldTypeDef[];
  onSelect: (type: FieldTypeCode) => void;
}

export function FieldPalette({ types, onSelect }: FieldPaletteProps) {
  return (
    <Paper withBorder p="sm" radius="md">
      <Text size="sm" fw={600} mb="xs">Available Fields</Text>
      <Stack gap={4}>
        {types.map((type) => (
          <Button
            key={type.code}
            variant="subtle"
            justify="start"
            size="xs"
            leftSection={<IconPlus size={12} />}
            onClick={() => onSelect(type.code)}
          >
            {type.name}
          </Button>
        ))}
      </Stack>
    </Paper>
  );
}